export default __webpack_public_path__ + "static/image1-3a461981ede2b6abde73e3df9eca156d.png";